@if (image) {
  <img [attr.src]="image" [attr.alt]="label" />
}
<span class="mat-body-small">{{ label }}</span>
@if (removable) {
  <button mat-icon-button (click)="handleRemove()">
    <mat-icon>cancel</mat-icon>
  </button>
}
